module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('div', {
    staticClass: "row large-col columns large-centered",
    attrs: {
      "id": "menu_bar"
    }
  }, [_c('li', {
    class: _vm.menuItemStyle,
    attrs: {
      "id": "home_menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Accueil")])])], 1), _vm._v(" "), _c('li', {
    class: _vm.menuItemStyle,
    attrs: {
      "id": "news_menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-microphone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Actualités")])])], 1), _vm._v(" "), (_vm.isLogged) ? _c('li', {
    class: _vm.menuItemStyle,
    attrs: {
      "id": "ranking_menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'rankingGeneral'
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Classement")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('li', {
    class: _vm.menuItemStyle,
    attrs: {
      "id": "team_menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TeamList'
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Equipes")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('li', {
    class: _vm.menuItemStyle,
    attrs: {
      "id": "match_menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'matchReportList'
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Les matchs")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('li', {
    class: _vm.menuItemStyle,
    attrs: {
      "id": "other_menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'pageList'
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Règlement")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('li', {
    class: _vm.menuItemStyle,
    attrs: {
      "id": "admin_menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bingoedf'
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-trophy",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Tournois")])])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-180bbc20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/top-menu.vue
// module id = 714
// module chunks = 0